import { generatePath } from 'react-router';

export enum AppRoutePatterns {
  Home = '/',
  Chatbot = '/chatbot',
  Categories = '/categories',
  CategoryById = '/category/:categoryId',
  CategoryByUri = '/category/uri/:categoryUri',
  Search = '/search',
  ArticleById = '/article/id/:articleId',
  ArticleByUri = '/article/uri/:articleUri',
}

export const routePathObjects = Object.values(AppRoutePatterns).map(
  (path: AppRoutePatterns) => ({
    path,
  }),
);

export const appRoutes = {
  home: () => generatePath(AppRoutePatterns.Home),
  chatbot: () => generatePath(AppRoutePatterns.Chatbot),
  categories: () => generatePath(AppRoutePatterns.Categories),
  categoryById: (params: { categoryId: string }) =>
    generatePath(AppRoutePatterns.CategoryById, params),
  categoryByUri: (params: { categoryUri: string }) =>
    generatePath(AppRoutePatterns.CategoryByUri, params),
  search: () => generatePath(AppRoutePatterns.Search),
  articleById: (params: { articleId: string }) =>
    generatePath(AppRoutePatterns.ArticleById, params),
  articleByUri: (params: { articleUri: string }) =>
    generatePath(AppRoutePatterns.ArticleByUri, params),
};

export const dontFireBiEventNavigateState = {
  dontFireBiEvent: true,
};

export const isChatbotArticleState = {
  isChatbotArticle: true,
};
